import {
  FieldInfo,
  UserInputError,
} from "Store/eventFailed/errorDisplayedInterface";
import React, { useEffect } from "react";

import { AlertType } from "Components/Form/Alert";
import { fieldInputError } from "Store/eventFailed/errorDisplayedSlice";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { flattenObject } from "Utils/flattenObject";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";

interface Props {
  productName: INSURANCE_NAME_VALUE;
  stepId: string;
}

export const InputFailureTracker = ({
  productName,
  stepId,
}: Props): React.ReactElement | null => {
  const dispatch = useDispatch();
  const formikContext = useFormikContext();
  const { submitCount, errors } = formikContext;
  const listOfErrors = Object.entries(flattenObject(errors));

  useEffect(() => {
    if (listOfErrors.length > 0) {
      const fieldInfo: FieldInfo = {
        productName,
        stepId,
        alertType: AlertType.INPUT_ERROR_ALERT,
        additionalInfo: listOfErrors.map(
          ([key, value]) => `fieldId: ${key}, errorValue: ${value}`,
        ),
      };
      dispatch(
        fieldInputError({
          errorType: UserInputError.FIELD_INPUT_ERROR,
          fieldInfo,
        }),
      );
    }
  }, [submitCount]);

  return null;
};
